import { signal } from '@angular/core';
import { FieldTree, required, min, SchemaPathTree } from '@angular/forms/signals';
import { SelectedCableDto } from '../../../core/mceapi.client.generated';
import { Option, match, none, some, } from '../../../shared/functions/functional';

export interface SelectedCable {
  manufacturerGuid: string,
  sourceGuid: string,
  libraryGuid: string,
  csa: number;
}

export function defaultSelectedCable(): SelectedCable {
  return { manufacturerGuid: '', sourceGuid: '', libraryGuid: '', csa: 0 };
}

export function buildCableSelectionSchema(path: SchemaPathTree<SelectedCable>) {

  required(path.manufacturerGuid, { message: 'Cable manufacturer is required' });
  required(path.sourceGuid, { message: 'Cable source is required' });
  required(path.libraryGuid, { message: 'Cable library is required' });
  required(path.csa, { message: 'Cable CSA is required' });
  min(path.csa, 0.0001, { message: 'Cable CSA must be greater than 0' });
}

export function createCableSelection(dto: Option<SelectedCableDto>) {
  return signal<SelectedCable>(match(
    () => defaultSelectedCable(),
    (x: SelectedCableDto) => ({
      manufacturerGuid: x.manufacturerGuid ?? '',
      sourceGuid: x.sourceGuid ?? '',
      libraryGuid: x.libraryGuid ?? '',
      csa: x.csa ?? 0,
    })
  )(dto));
}

export function createCableSelectionDto(model: FieldTree<SelectedCable>) {
  return signal<Option<SelectedCableDto>>(
    isSelectedCableValid(model)()
      ? some({
        manufacturerGuid: model.manufacturerGuid().value(),
        sourceGuid: model.sourceGuid().value(),
        libraryGuid: model.libraryGuid().value(),
        csa: model.csa().value(),
      })
      : none);
}

export function isSelectedCableValid(model: FieldTree<SelectedCable>) {
  return signal(
    model.manufacturerGuid().value() !== ''
    && model.sourceGuid().value() !== ''
    && model.libraryGuid().value() !== ''
    && model.csa().value() > 0);
}

